<template>
  <div>
  <v-card max-width="100%">
    <v-data-table v-if="requestStatus"
      :headers="headers"
      :items="propsEmployees ? propsEmployees : employees"
      :items-per-page="15"
      item-key="guid"
      elevation="0"
      dense
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-5">
          <v-toolbar-title>Сотрудники</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            hint="Поиск по наименованию, коду, цене"
            persistent-hint
            single-line
            color="orange darken-3"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="orange darken-3"
            icon
            outlined
            small
            @click="getData()"
            class="mr-5"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
<!--          <OrderDialogForm-->
<!--            v-if="suppliers"-->
<!--            v-bind:suppliers="suppliers"-->
<!--          />-->
        </v-toolbar>
      </template>

    </v-data-table>
    <div v-else class="center text-center">
      Загрузка
    </div>
  </v-card>
  <EmployeesEventsTable/>
  </div>
</template>

<script>
import EmployeesEventsTable from "@/components/employees/EmployeesEventsTable";
export default {
  name: "EmployeesTable",
  props: {propsEmployees: Object},
  components: {EmployeesEventsTable},
  data: () => ({
    headers: [
      { text: "Имя", align: "center", value: "fullname" },
      { text: "ИИН", value: "iin" },
      { text: "Роль", value: "role" },
      { text: "Явок", value: "events__count" },
      { text: "Заработано", value: "salary" },
    ],
    search: '',
    requestStatus: false,
  }),
  computed: {
    employees() { return this.$store.getters.employees.filter(employee => employee?.fullname.length ) }
  },
  mounted() {
    if (this.$store.getters.employees.length) {
      this.requestStatus = true
      return;
    }
    this.getData()
  },
  methods: {
    getData() {
      this.requestStatus = false
      this.$client.getAllEmployees()
      .then((response) => {
        this.$store.dispatch("setEmployees", response.data);
        this.requestStatus = true
      })
    },
  },
};
</script>

<style scoped></style>
